export default {
	name: 'en-US',
	to: {
		common: {
			confirm: 'OK',
			cancel: 'Cancel',
			clear: 'Clear',
			more: 'More',
			index: 'Index',
			unlimit: 'All',
			select: 'Select',
			selectAll: 'Select All',
			inverse: 'Inverse',
			originalValue: 'Original Value：{0}',
			data: 'option1,option2,option3',
			noData: 'No data found',
			noDataDesc: 'Data retrieval required',
			noMatch: 'No matching data found.',
			now: 'Now',
			placeholder: {
				select: 'Please Select',
				input: 'Please Enter'
			}
		},
		validate: {
			desc: {
				en: 'English',
				enLower: 'Lowercase English letters',
				enUpper: 'Uppercase English letters',
				enNone: 'English letters',
				cn: 'Chinese',
				number: 'Numbers',
				integer: 'Integer',
				integerP: 'Positive Integer',
				integerN: 'Negative Integer',
				nature: 'Natural Number',
				date: 'Date',
				time: '24-hour time format',
				time12: '12-hour time format',
				money: 'Amount',
				ip: 'IPv4 Address Format',
				ipV6: 'IPv6 Address Format',
				password: 'Password',
				username: 'Username',
				name: 'Name',
				nameCn: 'Chinese Name',
				nameEn: 'English Name',
				email: 'Email Address',
				qq: 'QQ Number',
				wechat: 'WeChat ID',
				web: 'Website Information',
				uscc: 'Unified Social Credit Code',
				bank: 'Bank Card Number',
				phone: 'Mobile Phone Number',
				telphone: 'Landline Number',
				id: 'ID Number',
				passport: 'Passport Number',
				mac: 'MAC Address'
			},
			remark: {
				password: 'Including at least 1 uppercase letter, 1 lowercase letter, 1 digit, and 1 special character.',
				username: '4 to 16 characters, supporting only letters, numbers, underscores, and hyphens.'
			},
			tip: {
				common: '{0} format is incorrect. Please enter valid {1}',
				custom: '{0} format is incorrect',
				customRemark: '{0}format is incorrect. Please enter valid {1}',
				required: '{0} cannot be empty',
				requiredRemark: '{0} cannot be empty'
			}
		},
		input: {
			inputError: 'Invalid input',
			required: 'This field is required'
		},
		calendar: {
			year: {
				suffix: ''
			},
			month: {
				suffix: '',
				m1: 'Jan',
				m2: 'Feb',
				m3: 'Mar',
				m4: 'Apr',
				m5: 'May',
				m6: 'Jun',
				m7: 'Jul',
				m8: 'Aug',
				m9: 'Sep',
				m10: 'Oct',
				m11: 'Nov',
				m12: 'Dec'
			},
			week: {
				w0: 'Sun',
				w1: 'Mon',
				w2: 'Tue',
				w3: 'Wed',
				w4: 'Thu',
				w5: 'Fri',
				w6: 'Sat'
			},
			day: {
				holiday: 'Hol'
			},
			time: {
				title: 'Select a time',
				hPlaceholder: 'H',
				mPlaceholder: 'M',
				sPlaceholder: 'S'
			},
			tip: {
				error: {
					selectDate: 'Select a date'
				}
			}
		},
		ellipsis: {
			unfold: 'Unfold',
			fold: 'Fold'
		},
		guider: {
			dontShowAgain: "Don't show again",
			restart: 'Restart',
			finish: 'Done',
			skip: 'Skip',
			next: 'Next'
		},
		page: {
			total: '{0} records',
			pageCount: '{0} pages',
			pageSize: '{0}/page',
			go: 'Go',
			prevPage: 'Prev',
			nextPage: 'Next'
		},
		pic: {
			viewer: {
				full: 'Full Screen',
				restore: 'Original Scale'
			},
			tip: {
				error: {
					load: 'Failed to Load'
				}
			}
		},
		scroll: {
			tip: {
				error: {
					paramType: '{0} Parameter Type Error'
				}
			}
		},
		segment: {
			tip: {
				error: {
					res: 'Failed to retrieve data from {0}: {1}',
					api: 'Failed to retrieve data from {0}: API call error.'
				}
			}
		},
		switch: {
			changed: 'This has been changed.'
		},
		select: {
			noData: 'No Data',
			noMatch: 'No Match',
			filter: 'Filter',
			selectError: 'Invalid Selection',
			required: 'Required',
			input: {
				allSelected: 'All selected'
			},
			float: {
				title: 'Select {0}',
				titlePlaceholder: 'Please Select'
			},
			tip: {
				error: {
					res: 'Failed to retrieve data from {0}: {1}',
					api: 'Failed to retrieve data from {0}: API call error.',
					repetition: 'The option you are trying to add has already been selected. Please make the necessary changes and try again.'
				}
			}
		},
		cascader: {
			placeholder: 'Please Select',
			noData: 'No Data',
			inputError: 'Invalid Selection',
			required: 'Required'
		},
		export: {
			button: 'Export',
			input: {
				placeholder: 'Enter the file name.'
			},
			tip: {
				ready: 'Export settings completed, please click Export.',
				start: 'Start exporting {0}',
				success: 'Export completed.',
				error: {
					filename: 'Please enter or modify the file name to export'
				}
			}
		},
		import: {
			button: 'Import',
			template: 'Download Template',
			tip: {
				submit: 'Start Upload: {0}',
				placeholder: 'Please select the file to import',
				error: {
					type: 'Invalid file type!',
					size: 'File size exceeds the limit!"'
				}
			}
		},
		upload: {
			button: 'Upload',
			tip: {
				selected: '{0} files selected',
				error: {
					selected: '{0}，{1} of them do not meet the requirements.',
					format: 'The file format is incorrect. Please upload {0} format files.',
					size: 'The file size exceeds the limit: {0}',
					count: 'You can upload a maximum of {0} files'
				}
			}
		},
		table: {
			emptyText: 'No Data'
		}
	}
}
